/*! data-type: highcontrastmode */
(function() {
  'use strict';

  function highcontrastMode() {
    if (document.body.classList.contains('highcontrast-mode')) {
      document.body.classList.remove('highcontrast-mode');
      localStorage.setItem('highcontrast-mode', 'false');
    } else {
      document.body.classList.add('highcontrast-mode');
      localStorage.setItem('highcontrast-mode', 'true');
    }
  }

  // add event listener to all highcontrastmode buttons
  var hcm = document.querySelectorAll("[data-type='highcontrastmode']");
  if (hcm) {
    for (let i = 0; i < hcm.length; i++) {
      hcm[i].addEventListener('click', highcontrastMode);
    }
    if (localStorage.getItem('highcontrast-mode') &&
      (localStorage.getItem('highcontrast-mode') == 'true')) {
      document.body.classList.add('highcontrast-mode');
    }
  }
})();
